export const validParams = (obj: Record<string, any>) => {
  const o: Record<string, any> = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (value && Number(value) !== 0) o[key] = value;
  });
  return o;
};
